import { DiscordOutlined } from '@ant-design/icons'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderDiscordCommon } from '../common'
import { FormConnectSteps } from './FormConnectSteps'
import { FormSetupSteps } from './FormSetupSteps'

export const ProviderDiscordClient: ProviderClient = {
  key: ProviderDiscordCommon.key,
  authentication: ProviderAuthenticationClient.Form({
    ...ProviderDiscordCommon.authentication,
    inputs: [],
  }),
  description: {
    label: 'Discord',
    icon: <DiscordOutlined />,
    triggers: [
      {
        key: 'newMessage',
        label: 'New message',
        input: [
          {
            key: 'channelIds',
            type: 'array',
            propsFormItem: {
              label: 'Channels',
              rules: [
                {
                  required: true,
                  message: 'You must select at least one channel',
                },
              ],
            },
            propsInput: {
              placeholder: 'Select channels',
            },
          },
        ],
        output: [
          {
            key: 'botId',
          },
          {
            key: 'user.id',
          },
          {
            key: 'user.username',
          },
          {
            key: 'user.pictureUrl',
          },
          {
            key: 'member.id',
          },
          {
            key: 'isMemberAdmin',
            type: 'boolean',
          },
          {
            key: 'message.id',
          },
          {
            key: 'message.author.id',
          },
          {
            key: 'message.author.username',
          },
          {
            key: 'message.channelId',
          },
          {
            key: 'message.threadId',
          },
          {
            key: 'message.content',
          },
          {
            key: 'message.guildId',
          },
        ],
      },
      {
        key: 'newReaction',
        label: 'New reaction',
        output: [
          {
            key: 'botId',
          },
          {
            key: 'user.id',
          },
          {
            key: 'user.username',
          },
          {
            key: 'user.pictureUrl',
          },
          {
            key: 'member.id',
          },
          {
            key: 'isMemberAdmin',
            type: 'boolean',
          },
          {
            key: 'message.id',
          },
          {
            key: 'message.author.id',
          },
          {
            key: 'message.author.username',
          },
          {
            key: 'message.channelId',
          },
          {
            key: 'message.threadId',
          },
          {
            key: 'message.content',
          },
          {
            key: 'message.guildId',
          },
          {
            key: 'reaction.emoji',
          },
        ],
      },
    ],
    actions: [
      {
        key: 'findManyChannelsByIds',
        label: 'Find many channels',
        input: [
          {
            key: 'channelIds',
          },
        ],
        output: [],
      },
      {
        key: 'findManyChannelsByServerId',
        label: 'Find many channels by server',
        input: [
          {
            key: 'serverId',
          },
        ],
        output: [],
      },
      {
        key: 'findManyMessagesByChannel',
        label: 'Find many messages by channel',
        input: [
          {
            key: 'channelId',
          },
        ],
        output: [],
      },
      {
        key: 'findManyMessagesByThread',
        label: 'Find many messages by thread',
        input: [
          {
            key: 'channelId',
          },
        ],
        output: [],
      },
      {
        key: 'reactToMessage',
        label: 'React to message',
        input: [
          {
            key: 'channelId',
          },
          {
            key: 'messageId',
          },
          {
            key: 'emoji',
          },
        ],
        output: [],
      },
      {
        key: 'sendMessageToChannel',
        label: 'Send a message to a channel',
        input: [
          {
            key: 'channelId',
          },
          {
            key: 'content',
          },
        ],
        output: [
          {
            key: 'id',
          },
        ],
      },
      {
        key: 'sendMessageToThread',
        label: 'Send a message to a thread',
        input: [
          {
            key: 'threadId',
          },
          {
            key: 'content',
          },
        ],
        output: [
          {
            key: 'id',
          },
        ],
      },
    ],
  },
  FormSetupSteps,
  FormConnectSteps,
}
